export default {
  header: 'Steps',
  days: 'days',
};
